export enum FilterStatus {
  All = 'All',
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
  NotRevoked = 'Not Revoked',
  RevokedOffChainOnly = 'Revoked Off-Chain Only',
  Revoked = 'Revoked',
  Expired = 'Expired',
}
